import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["manageDialog", "scheduleDialog"]

  connect() {
    if (window.location.hash === "#inbox-viewing-schedule") {
      if (this.hasManageDialogTarget) this.openManage()
      else if (this.hasScheduleDialogTarget) this.openSchedule()
    }
  }

  openManage(event) {
    event?.preventDefault()
    if (!this.hasManageDialogTarget) return

    this.manageDialogTarget.showModal()
    this.setHash()
  }

  openSchedule(event) {
    event?.preventDefault()
    if (!this.hasScheduleDialogTarget) return

    this.scheduleDialogTarget.showModal()
    this.setHash()
  }

  openScheduleWithPrefill({ date, time, notes } = {}) {
    this.openSchedule()

    const dateField = document.getElementById("viewing-date")
    const timeField = document.getElementById("viewing-time")
    const notesField = document.getElementById("viewing-notes")

    if (dateField && date) dateField.value = date
    if (timeField && time) timeField.value = time
    if (notesField && notes) notesField.value = notes

    dateField?.dispatchEvent(new Event("change", { bubbles: true }))
  }

  setHash() {
    if (window.location.hash !== "#inbox-viewing-schedule") {
      history.replaceState(null, "", `${window.location.pathname}${window.location.search}#inbox-viewing-schedule`)
    }
  }
}
